import { render, staticRenderFns } from "./Cashier.vue?vue&type=template&id=be6f912a&"
import script from "./Cashier.vue?vue&type=script&lang=js&"
export * from "./Cashier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports